export default "__VITE_ASSET__DzqJGjkw__"